<form #form="ngForm" novalidate
    class="nota-form-insert">
    <div class="card">
        <div class="card-body insert-click" *ngIf="!isInserting" (click)="insertClick()">
            <span>Escreva uma nota...</span>
        </div>

        <sgt-rich-text-editor
          *ngIf="isInserting && nota"
          [(ngModel)]="nota.texto"
          name="notaTexto"
          id="notaTexto"
          #notaTexto="ngModel"
          [control]="notaTexto.control"
          [settings]="{
            required: true,
            autofocus: true
          }"
          placeholder="Escreva uma nota...">
        </sgt-rich-text-editor>

        <div class="card-footer">
            <button type="button" class="btn btn-sm btn-light mr-2" (click)="cancel()" *ngIf="isInserting">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
            <button type="button" class="btn btn-sm btn-primary" (click)="emitInsert()" [disabled]="!isInserting || form.invalid">
                <i class="fas fa-plus"></i> Adicionar Nota
            </button>
        </div>
    </div>
</form>
